import { logout, useProfile } from '@/Auth';

export const useMainLayout = () => {
  const { profile } = useProfile();

  const handleLogout = async () => {
    try {
      // Call logout to clear server session and local storage
      await logout();
    } catch (error) {
      // Even if logout fails on server, clear local state
      // eslint-disable-next-line no-console
      console.error('Logout error:', error);
    } finally {
      // Force a full page reload to clear all React state
      // Use replace to avoid leaving logout in browser history
      window.location.replace('/');
    }
  };

  const profileMenuOptions = {
    user: {
      name: profile?.name || '',
      email: profile?.email || '',
    },
    menuOptions: [],
    onLogOut: handleLogout,
  };

  return {
    profileMenuOptions,
  };
};
